export default "__VITE_ASSET__MFjYvTmt__"